import { render, staticRenderFns } from "./HeaderSetting.vue?vue&type=template&id=6ff3d9d1&"
import script from "./HeaderSetting.vue?vue&type=script&lang=js&"
export * from "./HeaderSetting.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSetting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports